<mat-sidenav-container>
  <mat-sidenav class="site-details-nav" position="end" [opened]="true" [disableClose]="true" mode="side" *ngIf="site.id">

    <mat-card appearance="outlined" class="rounded-0">
      <mat-card-content>
        <ng-container *ngIf="site.parent_site">
          <h4 class="text-white">{{ utils.getLangTerm('sites.singular', 'Site') }} #{{ site.parent_site.id }}</h4>
          <p>
            <b>Name</b>: {{ site.parent_site.name }} <br>
            <b>Address</b>: {{ site.parent_site.location }} <br>
            <b>Created At:</b> {{ (site.parent_site.date_created * 1000) | timezoneConvertMedium }}
          </p>
        </ng-container>

        <h4 class="text-white">{{ site.parent_site ? utils.getLangTerm('child-sites.singular', 'Subsite') : utils.getLangTerm('sites.singular', 'Site') }} #{{ site.id }}</h4>
        <p>
          <b>Name</b>: {{ site.name }} <br>
          <b>Address</b>: {{ site.location }} <br>
          <b>Created At:</b> {{ (site.date_created * 1000) | timezoneConvertMedium }}
        </p>
      </mat-card-content>

      <mat-card-actions>
        <button mat-button (click)="composeNewMessage(site.id)" matTooltip="Click this button to send a message to users associated with this {{ site.parent_site ? utils.getLangTerm('child-sites.singular', 'Subsite') : utils.getLangTerm('sites.singular', 'Site') }}.">
          <mat-icon>send</mat-icon>
          Send Message
        </button>
      </mat-card-actions>
    </mat-card>

    <mat-nav-list class="pt-0" dense>

      <a mat-list-item routerLink="details" routerLinkActive="active-submenu-item">
        <span class="menu-panel-text">Details</span>
      </a>

      <a mat-list-item routerLink="induction" routerLinkActive="active-submenu-item">
        <span class="menu-panel-text">Noticeboard</span>
      </a>

      <a mat-list-item routerLink="contractors" routerLinkActive="active-submenu-item">
        <span class="menu-panel-text">{{ utils.getLangTerm('contractors.plural', 'Contractors') }} (Sub-{{ utils.getLangTerm('safety-plans.abbreviation', 'Safety Plan') }}s)</span>
      </a>

      <a mat-list-item routerLink="managers" routerLinkActive="active-submenu-item">
        <span class="menu-panel-text">Managers</span>
      </a>

      <a mat-list-item routerLink="users-worked-on" routerLinkActive="active-submenu-item">
        <span class="menu-panel-text">Users Worked On</span>
      </a>

      <a mat-list-item routerLink="sssp-config" routerLinkActive="active-submenu-item">
        <span class="menu-panel-text">Main {{ utils.getLangTerm('safety-plans.singular', 'Safety Plan') }}</span>
      </a>

      <a mat-list-item routerLink="dynamic-forms" routerLinkActive="active-submenu-item">
        <span class="menu-panel-text">Forms</span>
      </a>

      <a mat-list-item routerLink="codes" routerLinkActive="active-submenu-item">
        <span class="menu-panel-text">QR Codes</span>
      </a>

      <a mat-list-item routerLink="folders" routerLinkActive="active-submenu-item">
        <span class="menu-panel-text">Documents</span>
      </a>

      <a mat-list-item routerLink="assets" routerLinkActive="active-submenu-item">
        <span class="menu-panel-text">Asset Register</span>
      </a>

      <a mat-list-item routerLink="hazards" routerLinkActive="active-submenu-item">
        <span class="menu-panel-text">Hazards & Risks</span>
      </a>

      <a mat-list-item routerLink="hazardous-substances" routerLinkActive="active-submenu-item">
        <span class="menu-panel-text">{{ utils.getLangTerm('hazardous-substances.list.site-title', 'Hazardous Substances') }}</span>
      </a>

      <a mat-list-item routerLink="safety-observations" routerLinkActive="active-submenu-item">
        <span class="menu-panel-text">Safety Observations</span>
      </a>

      <a mat-list-item routerLink="incidents" routerLinkActive="active-submenu-item">
        <span class="menu-panel-text">Incidents</span>
      </a>

      <a mat-list-item routerLink="toolbox-talks" routerLinkActive="active-submenu-item">
        <span class="menu-panel-text">{{ utils.getLangTerm('toolbox-talks.plural', 'Toolbox Talks') }}</span>
      </a>

      <a mat-list-item routerLink="audits" routerLinkActive="active-submenu-item">
        <span class="menu-panel-text">Inspections & Audits</span>
      </a>

      <a mat-list-item routerLink="task-analyses" routerLinkActive="active-submenu-item">
        <span class="menu-panel-text">{{ utils.getLangTerm('task_analysis_documents.list.title', 'Task Analysis Documents') }} <i>(Legacy)</i></span>
      </a>

      <a mat-list-item routerLink="task-analyses-revised" routerLinkActive="active-submenu-item">
        <span class="menu-panel-text">{{ utils.getLangTerm('ta-jsa-swms.list.site-title', 'TA/JSA/SWMS Register') }}</span>
      </a>

      <a mat-list-item routerLink="emergency-evacuation-plans" routerLinkActive="active-submenu-item">
        <span class="menu-panel-text">Emergency Evacuation Plans</span>
      </a>

      <a mat-list-item routerLink="notifications" routerLinkActive="active-submenu-item">
        <span class="menu-panel-text">Notifications</span>
      </a>

    </mat-nav-list>

  </mat-sidenav>

  <section>
    <router-outlet></router-outlet>
  </section>
</mat-sidenav-container>

<ng-template #showLoader>
  <div class="d-flex justify-content-center align-items-center full-height">
    <table>
      <tr>
        <td class="d-flex justify-content-center">
          <mat-progress-spinner [mode]="'indeterminate'" diameter="32"></mat-progress-spinner>
        </td>
      </tr>
      <tr>
        <td class="d-flex justify-content-center">
          <p>Please wait while we get the information...</p>
        </td>
      </tr>
    </table>
  </div>
</ng-template>
